const { BiSelectMultiple } = require("react-icons/bi");
const { BsCash, BsCardText } = require("react-icons/bs");
const { CgSelectR } = require("react-icons/cg");
const { CiText } = require("react-icons/ci");
const { FaEye, FaRegCheckSquare, FaLink } = require("react-icons/fa");
const { GoContainer } = require("react-icons/go");
const { IoMdTime, IoMdColorFilter } = require("react-icons/io");
const { IoPhonePortraitSharp } = require("react-icons/io5");
const {
  MdOutlineMailOutline,
  MdDateRange,
  MdOutlineRadioButtonChecked,
  MdOutlineColorLens,
} = require("react-icons/md");
const { RiNumber1, RiCalendarEventFill } = require("react-icons/ri");

export const initialItems = [
  {
    id: "text",
    content: "Text",
    type: "text",
    icon: <CiText size={20} />,
  },
  {
    id: "password",
    content: "Password",
    type: "password",
    icon: <FaEye size={20} />,
  },
  {
    id: "currency",
    content: "Currency",
    type: "currency",
    icon: <BsCash size={20} />,
  },
  {
    id: "phone",
    content: "Phone",
    type: "phone",
    icon: <IoPhonePortraitSharp size={20} />,
  },
  {
    id: "email",
    content: "Email",
    type: "email",
    icon: <MdOutlineMailOutline size={20} />,
  },
  {
    id: "number",
    content: "Number",
    type: "number",
    icon: <RiNumber1 size={20} />,
  },
  {
    id: "date",
    content: "Date",
    type: "date",
    icon: <MdDateRange size={20} />,
  },
  {
    id: "dateAndTime",
    content: "Date & Time",
    type: "datetime-local",
    icon: <RiCalendarEventFill size={20} />,
  },
  {
    id: "time",
    content: "Time",
    type: "time",
    icon: <IoMdTime size={20} />,
  },
  {
    id: "checkbox",
    content: "Checkbox",
    type: "checkbox",
    icon: <FaRegCheckSquare size={20} />,
  },
  {
    id: "textArea",
    content: "Rich Text",
    type: "textarea",
    icon: <BsCardText size={20} />,
  },
  {
    id: "radioBox",
    content: "Radio Box",
    type: "radio",
    icon: <MdOutlineRadioButtonChecked size={20} />,
  },
  {
    id: "select",
    content: "Select",
    type: "select",
    icon: <CgSelectR size={20} />,
  },
  {
    id: "multiSelect",
    content: "Multi Select",
    type: "multiSelect",
    icon: <BiSelectMultiple size={20} />,
  },
  // {
  //   id: "hierarchicalSelect",
  //   content: "Hierarchical Select",
  //   type: "hierarchicalSelect",
  //   icon: <VscTypeHierarchy size={20} />,
  // },
  {
    id: "colorPicker",
    content: "Color Picker",
    type: "color",
    icon: <IoMdColorFilter size={20} />,
  },
  {
    id: "colorselector",
    content: "Color Selector",
    type: "colorSelector",
    icon: <MdOutlineColorLens size={20} />,
  },

  {
    id: "hidden",
    content: "Hidden",
    type: "hidden",
    icon: <FaEye size={20} />,
  },
  {
    id: "url",
    content: "URL",
    type: "url",
    icon: <FaLink size={20} />,
  },
  {
    id: "container",
    content: "Container",
    type: "container",
    icon: <GoContainer />,
  },
];
